import { OrderType } from 'enums';
import { CashbackPage } from 'features/cashback';

export const TechOperatorPayinCashbackPage: React.FC = () => (
  <CashbackPage orderType={OrderType.Payin} />
);
